// extracted by mini-css-extract-plugin
export default {"content":"Summary_content__z4Lzb","left":"Summary_left__bBA7Z","right":"Summary_right__0bcQ+"};